module.exports = __webpack_public_path__ + "static/media/logo.2b78d9e1.png";